import { __extends } from "tslib";
import { wrapAVM1NativeClass } from './AVM1Utils';
import { TextField } from '@awayjs/scene';
import { AVMStage, notImplemented } from '@awayfl/swf-loader';
import { AVM1Object } from '../runtime/AVM1Object';
var AVM1Selection = /** @class */ (function (_super) {
    __extends(AVM1Selection, _super);
    function AVM1Selection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.url = '';
        _this.targetMC = null;
        _this._queued_focus_value = null;
        _this._queued_focus = false;
        _this.callbackName = '';
        _this.callbackTarget = null;
        return _this;
    }
    AVM1Selection.createAVM1Class = function (context) {
        var wrapped = wrapAVM1NativeClass(context, true, AVM1Selection, [], ['addListener', 'getFocus', 'getBeginIndex', 'getEndIndex',
            'removeListener', 'setFocus', 'setSelection', 'getCaretIndex'], null, AVM1Selection.prototype.avm1Constructor);
        return wrapped;
    };
    AVM1Selection.prototype.avm1Constructor = function (url, targetMC) {
        this.url = url;
        this.targetMC = targetMC;
        this._queued_focus = false;
    };
    //	Registers an object to receive keyboard focus change notifications.
    AVM1Selection.prototype.addListener = function (listener) {
        notImplemented('AVM1Selection.addListener');
    };
    //	Removes an object previously registered with the Selection.addListener() method.
    AVM1Selection.prototype.removeListener = function (listener) {
        notImplemented('AVM1Selection.removeListener');
        return true;
    };
    AVM1Selection.prototype.getBeginIndex = function () {
        var _a;
        var objectinFocus = (_a = AVMStage.instance().mouseManager
            .getFocus()) === null || _a === void 0 ? void 0 : _a.container;
        if (objectinFocus && objectinFocus.isAsset(TextField))
            return objectinFocus.selectionBeginIndex;
        return -1;
    };
    AVM1Selection.prototype.getEndIndex = function () {
        var _a;
        var objectinFocus = (_a = AVMStage.instance().mouseManager
            .getFocus()) === null || _a === void 0 ? void 0 : _a.container;
        if (objectinFocus && objectinFocus.isAsset(TextField))
            return objectinFocus.selectionEndIndex;
        return -1;
    };
    AVM1Selection.prototype.getCaretIndex = function () {
        var _a;
        var objectinFocus = (_a = AVMStage.instance().mouseManager
            .getFocus()) === null || _a === void 0 ? void 0 : _a.container;
        if (objectinFocus && objectinFocus.isAsset(TextField))
            return objectinFocus.selectionBeginIndex;
        return -1;
    };
    // 	Returns a string specifying the target path of the object that has focus.
    AVM1Selection.prototype.getFocus = function () {
        var _a;
        var objectinFocus = (_a = AVMStage.instance().mouseManager
            .getFocus()) === null || _a === void 0 ? void 0 : _a.container;
        if (objectinFocus) {
            var names = [];
            while (objectinFocus) {
                if (objectinFocus.isAVMScene) {
                    objectinFocus = null;
                }
                else {
                    names.push(objectinFocus.name);
                    objectinFocus = objectinFocus.parent;
                }
            }
            var i = names.length;
            var mc_path = '';
            while (i > 0) {
                i--;
                mc_path += names[i];
                if (i > 0)
                    mc_path += '.';
            }
            //console.log(mc_path);
            return mc_path;
        }
        return '';
    };
    // 	Gives focus to the selectable (editable) text field, button, or movie clip,
    //	that the newFocus parameter specifies.
    //	also might be a path to a variable that is bound to a textfield.
    //	in that case we want to focus the textfield
    //	todo: potential bug (?):
    //	it might happen that this variable is not yet defined, because that script has not run yet
    //	either queue the getFocus, or maybe add it as a callback for MosueManager to execute before fireEvents?
    AVM1Selection.prototype.setFocus = function (newFocus) {
        if (newFocus === '')
            return;
        var focusObj;
        if (typeof newFocus === 'string') {
            focusObj = this.context.resolveTarget(newFocus);
            if (focusObj && focusObj.node) {
                AVMStage.instance().mouseManager
                    .setFocus(focusObj.node);
                return;
            }
            focusObj = this.context.resolveTarget(newFocus + '_internal_TF');
            if (focusObj && focusObj.node) {
                AVMStage.instance().mouseManager
                    .setFocus(focusObj.node);
                return;
            }
            console.warn('AVM1Selection.setFocus - no object found for string ' + newFocus);
            return;
        }
        focusObj = this.context.resolveTarget(newFocus);
        if (focusObj && focusObj.node) {
            AVMStage.instance().mouseManager
                .setFocus(focusObj.node);
        }
        else {
            console.warn('AVM1Selection.setFocus - no object found \'' + newFocus.toString() + '\'');
        }
        return true;
    };
    // Sets the selection span of the currently focused text field.
    AVM1Selection.prototype.setSelection = function (beginIndex, endIndex) {
        var _a;
        var objectinFocus = (_a = AVMStage.instance().mouseManager
            .getFocus()) === null || _a === void 0 ? void 0 : _a.container;
        if (objectinFocus && objectinFocus.isAsset(TextField)) {
            objectinFocus.setSelection(beginIndex, endIndex);
        }
    };
    return AVM1Selection;
}(AVM1Object));
export { AVM1Selection };
